import { CircularProgress, Dialog } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { deleteCart, deleteCartItem } from "../../../../services/purchaseApi";
import { useState } from "react";
import ErrorPopup from "../../../common/particles.jsx/ErrorPopup";
import { useAddToCartPbf } from "../../../hooks/purchaseHook/addToCartPbf";

const RemoveProductCartPopup = ({
  open,
  setOpen,
  productArr,
  closeFunc,
  successCloseFunc,
  isAll,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const addToCart = useAddToCartPbf();

  const handleClose = () => {
    closeFunc();
    setOpen(false);
  };

  const handleCloseSuccess = () => {
    successCloseFunc();
    setOpen(false);
  };

  const handleRemove = () => {
    if (isAll) mutateDeleteAll();
    if (productArr.length > 0 && !isAll) {
      const body = {
        product_uuids: productArr.map((item) => item.pbf_product_uuid),
      };

      mutateDeleteItem(body);
    }
  };

  // delete all function
  const { mutate: mutateDeleteAll, isLoading: isLoadingDelete } = useMutation({
    mutationFn: deleteCart,
    onSuccess: () => {
      handleCloseSuccess();
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  // singular/multiple delete function
  const { mutate: mutateDeleteItem, isLoading: isLoadingDeleteItem } =
    useMutation({
      mutationFn: deleteCartItem,
      onSuccess: () => {
        handleCloseSuccess();
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  return (
    <div>
      <Dialog
        onClose={handleClose}
        open={open}
        PaperProps={{ sx: { borderRadius: "16px" } }}
      >
        <div className="py-4 px-8 bg-white text-center">
          <p className="text-[20px] mb-2">Hapus {productArr.length} produk?</p>
          <p className="text-[16px] mb-4">
            Produk yang kamu pilih akan dihapus dari keranjang belanja
          </p>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="py-2 w-full rounded-md hover:bg-gray-300 border-2 border-red-500 text-red-500 bg-red-100 disabled:bg-gray-300 disabled:border-none disabled:text-white"
              onClick={handleClose}
              disabled={isLoadingDelete || isLoadingDeleteItem}
            >
              Batal
            </button>
            <button
              type="button"
              className="py-2 w-full rounded-md hover:bg-gray-300 border-red-500 text-white bg-red-500 disabled:bg-gray-300 disabled:border-none disabled:text-white"
              onClick={handleRemove}
              disabled={isLoadingDelete || isLoadingDeleteItem}
            >
              {isLoadingDelete || isLoadingDeleteItem ? (
                <CircularProgress size={10} />
              ) : (
                "Hapus"
              )}
            </button>
          </div>
        </div>
      </Dialog>
      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default RemoveProductCartPopup;
